export default __webpack_public_path__ + "media/images/question-mark-4bb214dda91b6bc27c6dca276d524ac6.svg";